import React from "react";

export default function ContactPage() {
  return (
    <div style={{ padding: 24, textAlign: "center", fontFamily: "Inter, sans-serif" }}>
      <h1 style={{ fontSize: 24, marginBottom: 16 }}>Kontakt z LunGO</h1>

      <p style={{ fontSize: 16, marginBottom: 8 }}>
        Masz pytania lub chcesz się z nami skontaktować?
      </p>

      <div style={{ marginTop: 24, lineHeight: 1.6 }}>
        <p><strong>📍 Adres korespondencyjny:</strong></p>
        <p>Burgizza Sp. z o.o.<br />
        ul. Kalwaryjska 69/9<br />
        30-504 Kraków, Polska</p>

        <p><strong>📧 E-mail kontaktowy:</strong></p>
        <p>
          <a href="mailto:support@lungoapp.pl">support@lungoapp.pl</a>
        </p>

        <p><strong>📧 Prywatność i dane osobowe:</strong></p>
        <p>
          <a href="mailto:privacy@lungoapp.pl">privacy@lungoapp.pl</a>
        </p>
      </div>
    </div>
  );
}
